import { createPortal } from "react-dom";

import styles from "./Modal.module.css";

export type ModalProps = {
  children: React.ReactNode;
  visible: boolean;
  onDismiss: () => void;
  variant?: "regular" | "no-padding" | "fullscreen";
  /** Keeps the dialog centered on narrow screens instead of the default bottom-sheet anchoring. */
  centerOnMobile?: boolean;
};

function Modal({
  children,
  visible,
  onDismiss,
  variant = "regular",
  centerOnMobile = false,
}: ModalProps) {
  if (!visible) return null;

  const portalTarget = document.getElementById("root") ?? document.body;

  const variantClassNames = {
    regular: styles.regular,
    "no-padding": styles["no-padding"],
    fullscreen: styles.fullscreen,
  };

  return createPortal(
    <div
      className={
        styles.modal +
        " fade-in" +
        (centerOnMobile ? ` ${styles.centered}` : "")
      }
      onClick={(e) => {
        e.stopPropagation();
        onDismiss && onDismiss();
      }}
    >
      <div
        className={
          styles.dialog +
          ` ${variantClassNames[variant]} ${centerOnMobile ? styles.centeredDialog : styles.dialogAnimation}`
        }
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {children}
      </div>
    </div>,
    portalTarget
  );
}
export default Modal;
